export default "__VITE_ASSET__BfwjRiPm__"